import api from '@/services/api'

const RESOURCE_URI = '/payment'

const createPayment = (payload) => {
  // 1) Se vier um ARRAY de pagamentos, envia o array diretamente
  if (Array.isArray(payload)) {
    return api.post(RESOURCE_URI, payload)
  }

  // 2) Se vier como wrapper { payments: [...] }, também envia o array
  if (payload && Array.isArray(payload.payments)) {
    return api.post(RESOURCE_URI, payload.payments)
  }

  // 3) Caso único (retrocompatível)
  const { type, amount, checkoutId, productId, rentId } = payload || {}
  return api.post(RESOURCE_URI, { type, amount, checkoutId, productId, rentId })
}

const deleteProductSale = ({ id, productId }) =>
  api.post(`${RESOURCE_URI}/delete-product-sale`, { id, productId })

export default {
  createPayment,
  deleteProductSale
}
